import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Radio } from "lucide-react";

export default function AdminGroups() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", platform: "whatsapp", url: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/groups").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.url) return;
    setBusy(true);
    try {
      await api.post("/groups", form);
      toast.success("Grupo adicionado");
      setForm({ name: "", platform: "whatsapp", url: "" });
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const remove = async (g) => {
    if (!window.confirm(`Remover '${g.name}'?`)) return;
    await api.delete(`/groups/${g.id}`);
    load();
  };

  const inputCls = "w-full px-3 py-2.5 rounded-xl bg-[var(--muted)] border border-[var(--border)] focus:outline-none focus:ring-2 focus:ring-[var(--forest)]";

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow">Divulgação</div>
        <h1 className="font-heading text-5xl mt-2 flex items-center gap-3"><Radio className="w-8 h-8 text-[var(--forest)]"/> Grupos oficiais</h1>
        <p className="text-[var(--ink-soft)] mt-2 max-w-xl">Cole aqui os convites/links de grupos oficiais de WhatsApp e Telegram. Aparecerão no botão "Partilhar" de cada vaga, ao dispor de referenciadores e administradores.</p>
      </div>

      <form onSubmit={add} className="card-surface p-6 grid md:grid-cols-4 gap-3">
        <input required placeholder="Nome (ex: CARING · Porto)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="group-name-input"/>
        <select value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })} className={inputCls} data-testid="group-platform-select">
          <option value="whatsapp">WhatsApp</option>
          <option value="telegram">Telegram</option>
          <option value="other">Outro</option>
        </select>
        <input required placeholder="URL do grupo" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className={`md:col-span-2 ${inputCls}`} data-testid="group-url-input"/>
        <button disabled={busy} className="pill-btn pill-primary md:col-span-4" data-testid="group-add-btn"><Plus className="w-4 h-4"/> {busy ? "A adicionar…" : "Adicionar grupo"}</button>
      </form>

      <div className="card-surface overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[var(--muted)] text-left">
              <th className="px-4 py-3">Nome</th>
              <th className="px-4 py-3">Plataforma</th>
              <th className="px-4 py-3">Link</th>
              <th className="px-4 py-3 text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((g) => (
              <tr key={g.id} className="border-t border-[var(--border)]">
                <td className="px-4 py-3 font-medium">{g.name}</td>
                <td className="px-4 py-3">
                  <span className="chip chip-neutral">
                    {g.platform === "whatsapp" ? "📱 WhatsApp" : g.platform === "telegram" ? "✈️ Telegram" : "🔗 Outro"}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-[var(--ink-soft)] truncate max-w-md">
                  <a href={g.url} target="_blank" rel="noreferrer" className="underline">{g.url}</a>
                </td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => remove(g)} className="pill-btn pill-ghost !py-1 !px-2 !text-red-600" data-testid={`remove-group-${g.id}`}>
                    <Trash2 className="w-3.5 h-3.5"/>
                  </button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-[var(--ink-soft)]">Sem grupos configurados.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
